export default "__VITE_ASSET__B0PAMj47__"